import ReactECharts from 'echarts-for-react';

function pieOption(data, title) {
  return {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    legend: { bottom: 0, type: 'scroll' },
    series: [{
      type: 'pie',
      radius: ['40%', '70%'],
      center: ['50%', '45%'],
      avoidLabelOverlap: false,
      itemStyle: { borderRadius: 4, borderColor: '#fff', borderWidth: 2 },
      label: { show: false },
      emphasis: { label: { show: true, fontSize: 14, fontWeight: 'bold' } },
      data: data.filter(d => d.value > 0),
    }],
  };
}

function barOption(data, title, horiz = true) {
  const sorted = [...data].sort((a, b) => b.value - a.value);
  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 140, right: 30, top: 10, bottom: 20 },
    [horiz ? 'yAxis' : 'xAxis']: {
      type: 'category',
      data: sorted.map(d => d.name),
      axisLabel: { fontSize: 11, overflow: 'truncate', width: 120 },
      inverse: true,
    },
    [horiz ? 'xAxis' : 'yAxis']: { type: 'value' },
    series: [{
      type: 'bar',
      data: sorted.map(d => d.value),
      itemStyle: {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 1, y2: 0,
          colorStops: [
            { offset: 0, color: '#1677ff' },
            { offset: 1, color: '#69b1ff' },
          ],
        },
        borderRadius: [0, 4, 4, 0],
      },
      barMaxWidth: 30,
    }],
  };
}

function formatAmount(val) {
  if (Math.abs(val) >= 1e8) return (val / 1e8).toFixed(1) + '亿';
  if (Math.abs(val) >= 1e4) return (val / 1e4).toFixed(1) + '万';
  return val.toFixed(0);
}

function lineOption(data) {
  return {
    tooltip: {
      trigger: 'axis',
      formatter: (p) => `${p[0].name}<br/>${formatAmount(p[0].value)}`,
    },
    grid: { left: 50, right: 20, top: 20, bottom: 30 },
    xAxis: {
      type: 'category',
      data: data.months,
      boundaryGap: false,
    },
    yAxis: {
      type: 'value',
      axisLabel: { formatter: (v) => formatAmount(v) },
    },
    series: [{
      type: 'line',
      data: data.values,
      smooth: true,
      symbol: 'circle',
      symbolSize: 6,
      lineStyle: { color: '#1677ff', width: 2 },
      itemStyle: { color: '#1677ff' },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: 'rgba(22,119,255,0.2)' },
            { offset: 1, color: 'rgba(22,119,255,0.02)' },
          ],
        },
      },
    }],
  };
}

export default function ChartsPanel({ data }) {
  return (
    <div className="charts-grid">
      <div className="chart-card">
        <h3>BU BP 占比</h3>
        <ReactECharts option={pieOption(data.bu_distribution)} style={{ height: 280 }} />
      </div>

      <div className="chart-card">
        <h3>产品线 BP 排名</h3>
        <ReactECharts option={barOption(data.product_ranking)} style={{ height: 280 }} />
      </div>

      <div className="chart-card">
        <h3>月度 BP 趋势</h3>
        <ReactECharts option={lineOption(data.monthly_trend)} style={{ height: 280 }} />
      </div>

      <div className="chart-card">
        <h3>上级经销商 BP Top 10</h3>
        <ReactECharts option={barOption(data.top_parent_dealers)} style={{ height: 280 }} />
      </div>
    </div>
  );
}
